import ChatRoom from '../components/ChatRoom/ChatRoom'
import {connect} from 'react-redux'
import {actions} from '../modules/chat'

const mapStateToProps = (state, props) => {
  return {
    chatRoom: state.chat.chatrooms[props.chatroomId]
  }
}

const mapDispatchToProps = dispatch => {
  return {
    fetchMessages: (id) => dispatch(actions.fetchMessages(id)),
    updateTypingMessage: (message, chatroomId) => dispatch(actions.updateTypingMessage(message, chatroomId)),
    loadMoreMessages: (chatroomId, from) => dispatch(actions.loadMoreMessages(chatroomId, from))
  }
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ChatRoom)



// WEBPACK FOOTER //
// ./src/containers/ChatRoomContainer.js